<template>
  <div class="inline-spinner-overlay">
    <div class="inline-spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'InlineSpinner'
}
</script>

<style scoped>
.inline-spinner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: color-mix(in srgb, var(--bo-surface) 40%, transparent);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: inherit;
}

.inline-spinner {
  border: 3px solid #f3f3f3;
  border-top: 3px solid var(--bo-ink);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>